module.exports = __webpack_public_path__ + "static/media/5f60cd0e5e70c.32fb1469.jpg";